
    export class PartitionConfig {
        public partitionnum: number = 0;
        public partitionstartoffset: number = 0;
        public partitionsize: number = 0;
        public partitiontypeid: number = 0;
        public partitionsizefree: number = 0;
        public partitionletter: string = "";
        public partitionlabel: string = "";

    }
    import { defineComponent, PropType } from 'vue';

    

    export default defineComponent({
        data() {
            return {
                title: "",
                 longueurimage: 506,
                largeurimage:38,
            }
        },
        props: {
            desctitle: String,
            idcanvas: Number,
            capacity: Number,
            capacitystr:String,
            partitions: Array as PropType<PartitionConfig[]>,
        },
        mounted() {
            let iddisk: string = "1";
            if (this.idcanvas != null)
                iddisk = this.idcanvas.toString();
            this.title = this.desctitle + " " + iddisk;
            this.printdisk();
        },
        created() {
            window.addEventListener('resize', this.printdisk, { passive: true });
        },
        destroyed() {
            window.removeEventListener('resize', this.printdisk);
        },
       
        methods: {
             GetPartitionColor(id: number): string {
                let color: string = "";
                let partitionscolors: Map<number, string> | null = new Map<number, string>();
                partitionscolors.set(0, "#FFFFFF");
                partitionscolors.set(6, "#8BCD5F");//Fat16
                partitionscolors.set(7, "#D777C8");//NTFS
                partitionscolors.set(11, "#8BCD5F");//FAT32
                partitionscolors.set(12, "#8BCD5F");//FAT32
                partitionscolors.set(14, "#8BCD5F");//FAT32
                partitionscolors.set(168, "#0080FF");
                partitionscolors.set(175, "#0080FF");
                partitionscolors.set(130, "#C0C0C0");
                partitionscolors.set(131, "#808040");
                if (partitionscolors.has(id))
                    color = <string>partitionscolors.get(id);
                else
                    color = "#FF8000";
                partitionscolors.clear();
                partitionscolors = null;
                return color;
            },

     GetPartitionColorLegend(id: number): string {
                let color: string = "";
                let partitionscolors: Map<number, string> | null = new Map<number, string>();
                partitionscolors.set(0, "#FFFFFF");
                partitionscolors.set(6, "#59992f");//Fat16
                partitionscolors.set(7, "#8A3F7D");//NTFS
                partitionscolors.set(11, "#59992f");//FAT32
                partitionscolors.set(12, "#59992f");//FAT32
                partitionscolors.set(14, "#59992f");//FAT32
                partitionscolors.set(168, "#0080ff");
                partitionscolors.set(175, "#0080ff");
                partitionscolors.set(130, "#C0C0C0");
                partitionscolors.set(131, "#808040");
                if (partitionscolors.has(id))
                    color = <string>partitionscolors.get(id);
                else
                    color = "#FF8000";
                partitionscolors.clear();
                partitionscolors = null;
                return color;
            },
            Paint() {

                let elem = document.getElementById('dcdrive_' + this.idcanvas);
                if (elem === null)
                    return;
                let canvas = (elem as HTMLCanvasElement);
                this.longueurimage = canvas.getBoundingClientRect().width;
                this.largeurimage = (this.longueurimage * 38) / 506;
                const largeurrect: number = (24 * this.largeurimage ) / 38;
                const hauteurlegende: number = (14 * this.largeurimage ) / 38;
                let ctx = canvas.getContext('2d');
                if (ctx === null)
                    return;
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(0, 0, this.longueurimage, this.largeurimage);
                ctx.strokeStyle = "#000000";
                if (this.partitions != null && this.capacity!=null) {
                    for (const partition of this.partitions) {
                        if (partition.partitionnum == 0)
                            continue;
                        let deb, sizerect: number = 0;
                        if (this.capacity == 0) {
                            deb = 0;
                            sizerect = 0;
                        }
                        else {

                            deb = ((partition.partitionstartoffset * this.longueurimage) / this.capacity);
                            sizerect = ((partition.partitionsize * this.longueurimage) / this.capacity);
                        }
                        let color3: string = this.GetPartitionColor(partition.partitiontypeid);
                        let sizeused: number = 0;
                        if (partition.partitionsize != 0)
                            sizeused = (sizerect * (partition.partitionsize - partition.partitionsizefree) / partition.partitionsize);
                        else
                            sizeused = 0;
                        if (sizeused > sizerect)
                            sizeused = sizerect;
                        let colorlegende: string = this.GetPartitionColorLegend(partition.partitiontypeid);
                        ctx.fillStyle = color3;

                        ctx.fillRect(deb, 0, sizeused, largeurrect);
                        ctx.strokeStyle = "#000000";
                        ctx.lineWidth = 1;
                        ctx.beginPath();
                        ctx.moveTo(deb, 0);
                        ctx.lineTo(deb, this.largeurimage);
                        ctx.stroke();
                        ctx.closePath();

                        let fontsize: number = 9 * 1;
                        let boundsletter: TextMetrics = ctx.measureText(partition.partitionletter);
                        let boundslabel: TextMetrics = ctx.measureText(partition.partitionlabel);
                        let notletterafficher: boolean = ((fontsize > largeurrect) || (boundsletter.width > sizerect));
                        let notlabelafficher: boolean = (boundslabel.width > sizerect + 2);
                        if (!notletterafficher) {
                            ctx.fillStyle = "#000000";
                            ctx.font = "9px arial";
                            ctx.fillText(partition.partitionletter, deb + ((sizerect) / 2) - (boundsletter.width / 2), ((largeurrect + fontsize) / 2));
                        }
                        if (!notlabelafficher) {
                            ctx.font = "bold 9px arial";
                            ctx.fillStyle = colorlegende;
                            ctx.fillText(partition.partitionlabel, deb + 2, largeurrect + (hauteurlegende + fontsize) / 2);
                        }
                    }
                }
                ctx.font = "9px arial";
                ctx.strokeStyle = "#000000";
                ctx.lineWidth = 1;
                ctx.strokeRect(1, 1, this.longueurimage - 2, largeurrect);
            },
            printdisk() {
                this.Paint();
                requestAnimationFrame(() => this.Paint());
            }
        },
    });
